import axios from '../../utils/axios';

export interface DashboardMetrics {
  totalEnrolledStudents: {
    value: number;
    percentageChange: number;
  };
  totalEnrolledPrograms: {
    value: number;
    percentageChange: number;
  };
  studentsBySubject: {
    [subjectName: string]: number;
  };
  studentsByLevel: {
    [level: string]: number;
  };
}

export interface MonthlyData {
  month: number;
  value: number;
}

export interface DashboardCharts {
  studentsByMonth: { [year: number]: MonthlyData[] };
  programsByMonth: { [year: number]: MonthlyData[] };
}

export interface DashboardSummaryResponse {
  metrics: DashboardMetrics;
  charts: DashboardCharts;
}

const getDashboardSummary = async (year?: number): Promise<DashboardSummaryResponse> => {
  let url = '/api/dashboard/academic';
  if (year) {
    url += `?year=${year}`;
  }
  const response = await axios.get(url);
  return response.data.data;
};

const getEnrollmentsBySchoolLocation = async (year: number) => {
  const response = await axios.get(`/api/dashboard/academic/enrollments/school-location?year=${year}`);
  return response.data.data;
};

const getEnrollmentsByProgramLocation = async (year: number) => {
  const response = await axios.get(`/api/dashboard/academic/enrollments/program-location?year=${year}`);
  return response.data.data;
};

const getStudentsBySubjectLocation = async (year: number) => {
  const response = await axios.get(`/api/dashboard/academic/students/subject-location?year=${year}`);
  return response.data.data;
};

const getStudentsByLevelLocation = async (year: number) => {
  const response = await axios.get(`/api/dashboard/academic/students/level-location?year=${year}`);
  return response.data.data;
};

const getFinancialDashboardData = async (year: number) => {
  const response = await axios.get(`/api/dashboard/financial?year=${year}`);
  return response.data;
};

const getTotalIncomeData = async (year: number) => {
  const response = await axios.get(`/api/dashboard/financial/total-income?year=${year}`);
  return response.data;
};

const getIncomeBySubjectData = async (year: number) => {
  const response = await axios.get(`/api/dashboard/financial/income-by-subject?year=${year}`);
  return response.data;
};

const getIncomeByTuitionData = async (year: number) => {
  const response = await axios.get(`/api/dashboard/financial/income-by-tuition?year=${year}`);
  return response.data;
};

const getIncomeByFeeData = async (year: number) => {
  const response = await axios.get(`/api/dashboard/financial/income-by-fee?year=${year}`);
  return response.data;
};

const getIncomeByLevelData = async (year: number) => {
  const response = await axios.get(`/api/dashboard/financial/income-by-level?year=${year}`);
  return response.data;
};

export {
  getDashboardSummary,
  getEnrollmentsBySchoolLocation,
  getEnrollmentsByProgramLocation,
  getStudentsBySubjectLocation,
  getStudentsByLevelLocation,
  getFinancialDashboardData,
  getTotalIncomeData,
  getIncomeBySubjectData,
  getIncomeByTuitionData,
  getIncomeByFeeData,
  getIncomeByLevelData,
};
